import { Button, Row } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export const UploadRow = () => (
  <Row className="align-center">
    <Button icon={<UploadOutlined />} shape="round">
      Upload DOCX or PDF
    </Button>
    <p className="my-0 text-sm title ml-2">
      DOCX file will be converted and sent as PDF file
    </p>
  </Row>
);
